// @flow

export const getEllipseCoords = (xRadius: number, yRadius: number, angle: number) => ({
  x: Math.floor(xRadius * Math.cos(angle)),
  y: Math.floor(yRadius * Math.sin(angle)),
});

export const getRandomCoordsOnEllipse = (height: number, width: number) => {
  const xRadius = width / 2;
  const yRadius = height / 2;
  const randomAngle = Math.random() * 2 * Math.PI;
  return getEllipseCoords(xRadius, yRadius, randomAngle);
};

export const getRandomInt = (min: number, max: number): number =>
  Math.floor(Math.random() * (max - min + 1)) + min;

export const generateKeyframesCSS = (rules: Array<string>): string => {
  const keyframesPrefixes = ['@-webkit-keyframes', '@keyframes'];
  return keyframesPrefixes
    .map((prefix) => rules.map((rule) => prefix + ' ' + rule).join('\n'))
    .join('\n');
};

export default undefined;
